import mod from "-!./Chapter.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Chapter.js?vue&type=script&lang=js&"